// generated by genversion
export var version = '5.0.14';
//# sourceMappingURL=version.js.map